// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-group-users[data-v-23c4c94b]{max-height:400px;overflow-y:auto}.user-group-users-list tbody tr:first-child td[data-v-23c4c94b]{border-top:none}", ""]);
// Exports
module.exports = exports;
